<template>
  <el-card class="box-card detail-screen mb-25">
    <el-row class="title">
      <div class="box-img">
        <el-avatar :size="100" :src="user.avatar_image_url"/>
      </div>
      <div class="box-title text-left lh-100 font-weight-700">{{ user.first_name}} {{user.last_name}}</div>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.id') }}</span></el-col>
      <el-col :span="19"><span>{{ user.id }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.nickname') }}</span></el-col>
      <el-col :span="19"><span>{{ user.nickname }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.birthday') }}</span></el-col>
      <el-col :span="19"><span>{{formatDate(user.birthday)}}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.gender') }}</span></el-col>
      <el-col :span="19">
        <span>{{ user.gender_name }}</span><br>
      </el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.tel') }}</span></el-col>
      <el-col :span="19"><span>{{ user.tel }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.mail_address') }}</span></el-col>
      <el-col :span="19"><span>{{ user.mail_address }}</span></el-col>
    </el-row>
    <div class="group-input mt-0"><span>{{ $t('users.users_info') }}</span></div>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.created_at') }}</span></el-col>
      <el-col :span="19"><span>{{ formatDate(user.created_at) }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.last_login_datetime') }}</span></el-col>
      <el-col :span="19"><span>{{ user.last_login_datetime }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle" v-if="user.login_type !== $loginType.line">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.password') }}</span></el-col>
      <el-col :span="19"><span>**********</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.status') }}</span></el-col>
      <el-col :span="19"><span>{{ user.status_name }}</span></el-col>
    </el-row>
    <div class="group-input mt-0"><span>{{ $t('users.users_point') }}</span></div>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.point') }}</span></el-col>
      <el-col :span="19"><span>{{user.points}}ココロン ({{formatDate(Date.now())}} 時点）</span></el-col>
    </el-row>
    <el-row class="row-data border-bottom" align="middle">
      <el-col :span="5"><span class="label">{{ $t('users.detail_fields.user_point') }}</span></el-col>
      <el-col :span="19"><span>{{ user.used_point }}ココロン <span v-if="user.used_point != 0">(最終利用日:{{user.last_point_datetime}})</span></span></el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="text-center mt-25">
        <el-button type="primary" @click="redirectEdit" class="btn btn-edit">{{ $t('update') }}</el-button>
        <el-button @click="back" class="btn btn-back">{{ $t('back') }}</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>

export default {
  props: {
    user: { type: Object, required: true, default: {} },
    urls: { type: Object, required: true, default: {} },
  },
  data() {
    return {}
  },
  methods: {
    formatDate(dateTime) {
      return (dateTime) ? this.$dayjs(dateTime).format('YYYY/MM/DD') : '';
    },
    resetAccount() {
      this.isOpenPopupReset = true;
    },
    back() {
      window.location.href = this.urls.index;
    },
    redirectEdit() {
      window.location.href = this.urls.edit;
    },
    handleClosePopupReset() {
      this.isOpenPopupReset = false;
    },
  },
  created() {
  },
}
</script>
<style lang="scss" scoped>
.detail-screen {
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .title {
    font: normal normal normal 15px/33px Kozuka Gothic Pr6N;
    letter-spacing: 1.5px;
    color: #000000;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    .btn-open-close {
      font: normal normal normal 11px/20px Kozuka Gothic Pr6N;
      letter-spacing: 1.1px;
      color: #969696;
      margin-left: 20px;
      cursor: pointer;
    }
    .box-img {
      width: 100px;
    }
    .box-title {
      padding-left: 35px;
      width: calc(100% - 100px);
    }
    padding-bottom: 0px;
  }
  .main {
    color: #000000;
    .title {
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
    }
    .content {
      .point {
        font: normal normal bold 25px/23px Futura;
        letter-spacing: 0.25px;
      }
      .money {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        margin-left: 10px;
      }
    }
  }
}
</style>
